import React, { FC } from 'react';
import { Box, LottiePlayerECOMMBX } from '@dxb-web-ui-framework/design-system';

enum LoaderOverlaySize {
  'small' = 60,
  'large' = 500,
  'full' = '100%',
}

enum LoaderSpacing {
  small = 2,
  medium = 4,
  large = 8,
}

type ECOMMBXLoaderProps = {
  size?: 'small' | 'large' | 'full';
  verticalSpacing?: 'small' | 'medium' | 'large';
  horizontalSpacing?: 'small' | 'medium' | 'large';
};

const ECOMMBXLoader: FC<ECOMMBXLoaderProps> = ({ size, verticalSpacing, horizontalSpacing }) => (
  <Box
    height={size ? LoaderOverlaySize[size] : ''}
    px={horizontalSpacing ? LoaderSpacing[horizontalSpacing] : ''}
    py={verticalSpacing ? LoaderSpacing[verticalSpacing] : ''}
    display='flex'
    justifyContent='center'
    alignItems='center'>
    <LottiePlayerECOMMBX icon='ecommbx_loader' loop={true} play width={48} height={48} />
  </Box>
);

export { ECOMMBXLoader };
